import BaseModel from "./BaseModel";

/**
 * Budget
 */
export default class Budget extends BaseModel{

  constructor({
    email,
    name,
    category,
    company_name,
    company_type,
    company_website,
    delivery_time,
    idea,
    phone_number,
    service,
    selectedCountry
  }) {
    super();
    
    this.email = email || null;
    this.name = name || null;
    this.category = category || null;
    this.company_name = company_name || null;
    this.company_type = company_type || null;
    this.company_website = company_website || null;
    this.delivery_time = delivery_time || null;
    this.idea = idea || null;
    this.phone_number = phone_number || null;
    this.service = service || null;
    this.selectedCountry = selectedCountry || null;
  }
}